<template>
  <div class="d-flex">
    <!-- 스킬패스 고객사에 따라 아이콘 두개 분기 -->
    <div v-if="isSkillPath" class="d-flex">
      <div
        class="t-center d-flex flex-column header-info-round-wrapper cursor-pointer align-items-center"
        @click.prevent="goToMicroLearning"
        @keypress.prevent="goToMicroLearning"
        tabindex="0"
      >
        <span
          class="header-info-round t-headline9 t-color-whiteHigh bg-lectureRed font-b"
          >{{ microLearning }}</span
        >
        <span class="t-body3 t-color-bodyGrayA font-r mgt-6">{{
          $t("30224")
        }}</span>
      </div>
      <div
        class="t-center d-flex flex-column header-info-round-wrapper cursor-pointer align-items-center"
        @click.prevent="goToLearning"
        @keypress.prevent="goToLearning"
        tabindex="0"
      >
        <span
          class="header-info-round t-headline9 t-color-whiteHigh bg-lecturePurple font-b"
          >{{ learning }}</span
        >
        <span class="t-body3 t-color-bodyGrayA font-r mgt-6">{{
          $t("30225")
        }}</span>
      </div>
    </div>
    <div v-else class="d-flex">
      <div
        class="t-center d-flex flex-column header-info-round-wrapper cursor-pointer align-items-center"
        @click.prevent="goToLearning"
        @keypress.prevent="goToLearning"
        tabindex="0"
      >
        <span
          class="header-info-round t-headline9 t-color-whiteHigh bg-lectureRed font-b"
          >{{ learning }}</span
        >
        <span class="t-body3 t-color-bodyGrayA font-r mgt-6">{{
          $t("1738")
        }}</span>
      </div>
      <div
        class="t-center d-flex flex-column header-info-round-wrapper cursor-pointer align-items-center"
        @click.prevent="goToCompletion"
        @keypress.prevent="goToCompletion"
        tabindex="0"
      >
        <span
          class="header-info-round t-headline9 t-color-whiteHigh bg-lecturePurple font-b"
          >{{ completion }}</span
        >
        <span class="t-body3 t-color-bodyGrayA font-r mgt-6">{{
          $t("1739")
        }}</span>
      </div>
    </div>

    <div
      class="t-center d-flex flex-column header-info-round-wrapper cursor-pointer align-items-center"
      @click.prevent="goToMyTest"
      @keypress.prevent="goToMyTest"
      tabindex="0"
    >
      <span
        class="header-info-round t-headline9 t-color-whiteHigh bg-contentBlue font-b"
        >{{ eaxmTest }}</span
      >
      <span class="t-body3 t-color-bodyGrayA font-r mgt-6">{{
        $t("1740")
      }}</span>
    </div>
    <div
      class="t-center d-flex flex-column header-info-round-wrapper cursor-pointer align-items-center"
      @click.prevent="goToMySurvey"
      @keypress.prevent="goToMySurvey"
      tabindex="0"
    >
      <span
        class="header-info-round t-headline9 t-color-whiteHigh bg-lectureAqua font-b"
        >{{ survey }}</span
      >
      <span class="t-body3 t-color-bodyGrayA font-r mgt-6">{{
        $t("1741")
      }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainDashBoardCircleIcons",
  props: [
    "microLearning",
    "learning",
    "completion",
    "eaxmTest",
    "survey",
    "goToMicroLearning",
    "goToLearning",
    "goToCompletion",
    "goToMyTest",
    "goToMySurvey",
    "isSkillPath",
  ],
};
</script>

<style>
</style>